import React, { useState, useEffect } from 'react';
import { znsAPI } from '../services/api';
import '../styles/Dashboard.css';

function Dashboard() {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStatistics();
  }, []);

  const loadStatistics = async () => {
    try {
      const response = await znsAPI.getStatistics();
      if (response.data.success) {
        setStatistics(response.data.data);
      }
    } catch (error) {
      console.error('Load statistics error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">Đang tải...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Tổng quan hệ thống ZNS</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue">📨</div>
          <div className="stat-info">
            <h3>{statistics?.total || 0}</h3>
            <p>Tổng tin đã gửi</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">✅</div>
          <div className="stat-info">
            <h3>{statistics?.by_status?.find(s => s.status === 'sent')?.count || 0}</h3>
            <p>Gửi thành công</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon red">❌</div>
          <div className="stat-info">
            <h3>{statistics?.by_status?.find(s => s.status === 'failed')?.count || 0}</h3>
            <p>Gửi thất bại</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon yellow">⏳</div>
          <div className="stat-info">
            <h3>{statistics?.by_status?.find(s => s.status === 'pending')?.count || 0}</h3>
            <p>Đang xử lý</p>
          </div>
        </div>
      </div>

      <div className="content-grid">
        <div className="card">
          <h3>Template phổ biến</h3>
          <div className="template-list">
            {statistics?.by_template?.length > 0 ? (
              statistics.by_template.map((item, index) => (
                <div key={index} className="template-item">
                  <span className="template-name">{item.template_name}</span>
                  <span className="template-count">{item.count} tin</span>
                </div>
              ))
            ) : (
              <p className="empty-state">Chưa có dữ liệu</p>
            )}
          </div>
        </div>

        <div className="card">
          <h3>Hoạt động gần đây (7 ngày)</h3>
          <div className="activity-chart">
            {statistics?.daily?.length > 0 ? (
              statistics.daily.map((item, index) => (
                <div key={index} className="activity-item">
                  <span className="activity-date">{new Date(item.date).toLocaleDateString('vi-VN')}</span>
                  <div className="activity-bar">
                    <div 
                      className="bar-sent" 
                      style={{width: `${(item.sent_count / item.count) * 100}%`}}
                    />
                  </div>
                  <span className="activity-count">{item.count} tin</span>
                </div>
              ))
            ) : (
              <p className="empty-state">Chưa có dữ liệu</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;